import { useSetState, useDeepCompareEffect } from 'ahooks'
import { Form } from 'antd-mobile'
import React from 'react'

import NewEditForm from '@/components/NewEditForm'

import HPopup from '../../HYBVant/HPopup'
import './index.less'

const HealthCertificate: React.FC<any> = ({ visible, onCancel, modalData }) => {
  const {
    staff_Id,
    runDeleteTraining,
    runSaveTraining,
    deleteTrainingLoading,
    saveTrainingLoading,
    status,
    editItem
  } = modalData
  const [formIt] = Form.useForm()
  const [{ randomForm }, setState] = useSetState<any>({
    randomForm: null
  })
  console.log('status----editItem', status, editItem)
  const onFinish = (fieldValues: any) => {
    if (deleteTrainingLoading || saveTrainingLoading) return
    const values_info = {
      ...fieldValues,
      id: editItem?.id || null,
      trainer_id: fieldValues?.trainer_id?.[0] || null,
      employee_id: staff_Id
    }
    console.log('values_info--->>>', values_info)
    runSaveTraining([values_info])
  }

  useDeepCompareEffect(() => {
    const setFieldValues = (bool: boolean) => {
      const rowInfo = {
        ...editItem
      }
      formIt.setFieldsValue(rowInfo)

      setState({ randomForm: Math.random() })
    }
    setFieldValues(status === 'Edit')
  }, [status, editItem])
  const deleteInfo = () => {
    if (status === 'Edit') {
      const fields = editItem
      const id = fields?.id
      const ids = id ? [id] : null
      runDeleteTraining(ids)
    }
  }
  const getFormButtons = (hasDelete?: boolean) => {
    const btns = [
      {
        key: 'remove',
        title: '删除',
        className: 'delete-btn',
        onClick: deleteInfo
      },
      {
        key: 'submit',
        title: '保存'
      }
    ]
    return hasDelete ? btns : btns.slice(1)
  }
  const option = {
    formInfo: [
      {
        title: '培训记录',
        id: 'rewardPunishmentInfo',
        is_show_title: false,
        form_list: [
          {
            name: 'training_date',
            label: '培训日期',
            required: true,
            type: 'DatePicker',
            elementProps: {
              format: 'YYYY-MM-DD'
            }
          },
          {
            type: 'Personnel',
            required: false,
            formItemProps: {
              label: '培训员',
              name: 'trainer_id'
            },
            elementProps: {
              type: 'trainer_id',
              trainer_id: {}
            }
          },
          {
            name: 'training_hours',
            label: '培训小时数',
            required: true,
            type: 'InputNumber',
            placeholder: '请选择',
            elementProps: {
              precision: 2
            }
          },
          {
            name: 'training_course_name',
            label: '培训课程名称',
            required: true,
            placeholder: '请输入',
            type: 'Input',
            maxLength: 32
          },
          {
            type: 'InputNumber',
            name: 'training_score',
            label: '培训分数',
            elementProps: {
              max: 100,
              precision: 2
            }
          },
          {
            type: 'Switch',
            name: 'passed_training',
            label: '是否通过培训',
            required: false,
            formItemProps: {
              valuePropName: 'checked'
            }
          }
        ]
      }
    ]
  }
  return (
    <HPopup
      title='培训记录'
      hasOk={false}
      className='lg'
      visible={visible}
      onCancel={onCancel}
      destroyOnClose
    >
      <div className='income-tax-declaration-popup'>
        <NewEditForm
          formInst={formIt}
          formInfo={option?.formInfo ?? []}
          onFinish={onFinish}
          randomForm={randomForm}
          formButtons={getFormButtons(modalData?.status === 'Edit')}
        />
      </div>
    </HPopup>
  )
}

export default HealthCertificate
